module.exports = __webpack_public_path__ + "img/newpassport.79e2b9ab.png";